import GatewayBase from './gateway-base';

export default class ClaimsRestService extends GatewayBase {
  private claimsForOrder = (orderId: string) => {
    return this.client.get<any[]>(`/v1/claims/order/${orderId}`);
  };

  private getPolicyByOrderId = (orderId: string) => {
    return this.client.get<any>(`/v1/policies/${orderId}`);
  };

  private createPolicy = (data: any) => {
    return this.client.post<any>('/v1/policies', data);
  };

  get policies() {
    return {
      create: this.createPolicy,
      forOrder: this.getPolicyByOrderId,
    };
  }
  get claims() {
    return {
      counts: {
        forStores: this.getClaimCountsForStore,
      },
      credits: {
        delete: this.deleteStoreCredit,
        export: this.exportCredits,
        list: {
          get: this.getStoreCredits,
        },
        usage: {
          get: this.getClaimCreditUsage,
        },
      },
      export: {
        forStore: this.exportClaims,
      },
      forOrder: this.claimsForOrder,
      forStores: this.claimsForStore,
    };
  }

  private exportClaims = (body: unknown) => {
    return this.client.post<any>(`/v1/claims/export-claims`, body);
  };

  get reviews() {
    return {
      count: this.getReviewsCount,
      export: this.exportReviews,
      get: this.getReviews,
    };
  }
  private exportCredits = (body: unknown) => {
    return this.client.post<any>(`/v1/claims/credits/export`, body);
  };

  private deleteStoreCredit = (storeCreditId: string, storeId) => {
    return this.client.delete(`/v1/claims/credits/${storeCreditId}`, {
      params: { storeId },
    });
  };

  private getStoreCredits = (
    storeId: string,
    params?: {
      filters?: string;
      page?: number;
      limit?: number;
      createdAtMin?: Date;
      createdAtMax?: Date;
    },
  ) => {
    return this.client.get<any>(`/v1/claims/credits/list/${storeId}`, { params });
  };

  private getClaimCountsForStore = (
    storeIds: string[],
    params?: { filters?: string; createdAtMin?: Date; createdAtMax?: Date },
  ) => {
    return this.client.get<any>(`/v1/claims/counts/${storeIds.join(',')}`, { params });
  };

  private claimsForStore = (
    storeIds: string[],
    params?: {
      filters?: string;
      page?: number;
      limit?: number;
      createdAtMin?: Date;
      createdAtMax?: Date;
    },
  ) => {
    return this.client.get<any>(`/v1/claims/store/${storeIds.join(',')}`, { params });
  };

  private getClaimCreditUsage = (orderId: string) => {
    return this.client.get(`/v1/claims/credits/usages/${orderId}`);
  };

  private getReviews = (
    storeId: string,
    params?: { page?: number; limit?: number; createdAtMin?: Date; createdAtMax?: Date },
  ) => {
    return this.client.get(`/v1/claims/reviews/store/${storeId}`, { params });
  };

  private getReviewsCount = (storeId: string, params?: { createdAtMin?: Date; createdAtMax?: Date }) => {
    return this.client.get(`/v1/claims/reviews/store/${storeId}/count`, { params });
  };

  private exportReviews = (storeId: string, body?: { createdAtMin?: Date; createdAtMax?: Date }) => {
    return this.client.post(`/v1/claims/reviews/store/${storeId}/export`, body);
  };
}
